import ProductHome from "views/App/Products/ProductHome.jsx";
import ProductForm from "views/App/Products/ProductForm.jsx";
import ProductFieldLists from "views/App/Products/ProductFieldLists.jsx";
import ProductDetail from "views/App/Products/ProductDetail.jsx";
import Local from "views/App/Local.jsx";
import Offline from "views/App/Offline.jsx";
import NewSubstance from "views/App/Substances/NewSubstance.jsx";
import ProfileAnalyseResult from "views/App/Analyses/ProfileAnalyseResult.jsx";
import SubstancesAnalysesForm from "views/App/Analyses/SubstancesAnalysesForm";
import ClasseResult from "views/App/Analyses/ContreIndication/ClasseResult";
import DCIResult from "views/App/Analyses/ContreIndication/DCIResult";
import NomResult from "views/App/Analyses/ContreIndication/NomResult";
import NomCommercialResult from "views/App/Analyses/ContreIndication/NomCommercialResult";
import Equivalence from "views/App/Equivalence/Equivalence";
import Settings from "views/App/Settings/Settings.jsx";
import SubscriptionManagement from "views/App/Settings/SubscriptionManagement.jsx";
import MonProfil from "views/App/Profile/MonProfil.jsx";
import InteractionsMedicamenteusesView from "views/App/Analyses/InteractionsMedicamenteuses/InteractionsMedicamenteusesView.jsx";
import MultiparametricAnalysisPage from "../views/App/Analyses/Multiparametrique/MultiparametricAnalysisPageSimple.jsx";

// Imports pour les formations
import TrainingPage from "../views/App/TraningPages/TrainingPage.jsx";
import TrainingDetailPage from "../views/App/TraningPages/TrainingDetailPage.jsx";
import TrainingPurchasePage from "../views/App/TraningPages/TrainingPurchasePage.jsx";

// Imports pour les expériences
import ExperiencesHome from "views/App/Experiences/ExperiencesHome.jsx";

// Import pour la gestion de base de données
import DatabaseManagement from "views/App/Database/DatabaseManagement.jsx";
import ReportsManagement from "views/App/Reports/ReportsManagement.jsx";

// Imports pour l'administration
import AdminDashboard from "views/App/Dashboard/AdminDashboard.jsx";
import UserManagement from "views/App/Dashboard/UserManagement.jsx";
import AdminTrainingManagement from "views/App/Training/AdminTrainingManagement.jsx";
import AdminExperienceManagement from "views/App/Experiences/AdminExperienceManagement.jsx";
import AdminSubscriptionManagement from "views/App/Settings/AdminSubscriptionManagement.jsx";
import ProfessionsManagement from "views/App/ProfessionsManagement/ProfessionsManagement.jsx";
import StatisticsDashboard from "components/Statistics/StatisticsDashboard.jsx";

const routes = [
    {
        path: "/app/profile",
        name: "Mon Profil",
        component: MonProfil,
        icon: "pe-7s-user",
        hidden: true
    },
    {
        path: "/app/profile/settings",
        name: "Paramètres du Profil",
        component: Settings,
        icon: "pe-7s-user",
        hidden: true
    },
    {
        path: "/app/subscription",
        name: "Gestion Abonnement",
        component: SubscriptionManagement,
        icon: "pe-7s-star",
        hidden: true
    },
    {
        collapse: true,
        name: "Administration",
        icon: "pe-7s-settings",
        state: "adminCollapse",
        views: [
            {
                path: "/app/admin/dashboard",
                name: "Tableau de Bord Admin",
                component: AdminDashboard,
                icon: "pe-7s-graph1"
            },
            {
                path: "/app/admin/users",
                name: "Gestion Utilisateurs",
                component: UserManagement,
                icon: "pe-7s-users"
            },
            {
                path: "/app/admin/training",
                name: "Gestion Formations",
                component: AdminTrainingManagement,
                icon: "pe-7s-study"
            },
            {
                path: "/app/admin/database",
                name: "Base de Données",
                component: DatabaseManagement,
                icon: "pe-7s-server"
            },
            {
                path: "/app/admin/professions",
                name: "Gestion Professions",
                component: ProfessionsManagement,
                icon: "pe-7s-id"
            },
            {
                path: "/app/admin/experiences",
                name: "Gestion Expériences",
                component: AdminExperienceManagement,
                icon: "pe-7s-share"
            },
            {
                path: "/app/admin/subscriptions",
                name: "Gestion Abonnements",
                component: AdminSubscriptionManagement,
                icon: "pe-7s-star"
            },
            {
                path: "/app/admin/statistics",
                name: "Statistiques Sanitaires",
                component: StatisticsDashboard,
                icon: "pe-7s-graph2"
            },
            {
                path: "/app/admin/reports",
                name: "Rapports générés",
                component: ReportsManagement,
                icon: "pe-7s-note"
            },
        ]
    },
    // 1. DONNEES MEDICAMENTS
    {
        path: "/app/product/home",
        name: "Données Médicaments",
        component: ProductHome,
        icon: "pe-7s-news-paper"
    },
    // 2. EQUIVALENCE
    {
        path: "/app/analyse/equivalence",
        name: "Equivalence",
        component: Equivalence,
        icon: "pe-7s-repeat"
    },
    // 3. ANALYSE INTERACTIONS MED.
    {
        path: "/app/analyse/interactions",
        name: "Analyse Interactions Méd.",
        component: InteractionsMedicamenteusesView,
        icon: "pe-7s-refresh-2"
    },
    {
        path: "/app/analyse/analyses",
        name: "Analyse Interactions",
        component: SubstancesAnalysesForm,
        icon: "pe-7s-science",
        hidden: true
    },
    // 4. ANALYSE CONTRE-INDICATIONS
    {
        path: "/app/analyse/multiparametric",
        name: "Analyse Contre-Indications",
        component: MultiparametricAnalysisPage,
        icon: "pe-7s-graph1"
    },
    {
        path: "/app/analyse/profiles",
        name: "Analyse Contre-Indications",
        component: ProfileAnalyseResult,
        icon: "pe-7s-hourglass",
        hidden: true
    },
    // 5. FORMATION CONTINUE
    {
        path: "/app/training",
        name: "Formation Continue",
        component: TrainingPage,
        icon: "pe-7s-study"
    },
    {
        path: "/app/training/detail/:id",
        name: "Détail Formation",
        component: TrainingDetailPage,
        hidden: true
    },
    {
        path: "/app/training/purchase/:id",
        name: "Achat Formation",
        component: TrainingPurchasePage,
        hidden: true
    },
    // 6. PARTAGE D'EXPERIENCE
    {
        path: "/app/experiences",
        name: "Partage d'Expérience",
        component: ExperiencesHome,
        icon: "pe-7s-share"
    },

    {
        path: "/app/product/form/:id",
        name: "Product form",
        component: ProductForm,
        hidden: true
    },
    {
        path: "/app/product/field/lists/:id",
        name: "Product field lists",
        component: ProductFieldLists,
        hidden: true
    },
    {
        path: "/app/product/detail/:id",
        name: "Product detail",
        component: ProductDetail,
        hidden: true
    },

    {
        path: "/app/local",
        name: "Local",
        component: Local,
        icon: "pe-7s-map-marker",
        hidden: true
    },
    // 7. MODE HORS LIGNE
    {
        path: "/app/Offline",
        name: "Mode Hors Ligne",
        component: Offline,
        icon: "pe-7s-cloud-download"
    },

    /* Paramètres supprimés du sidebar
    {
        path: "/app/settings",
        name: "Paramètres",
        component: Settings,
        icon: "pe-7s-config"
    },
    */
     /*
    {
        path: "/app/substance/liste",
        name: "Substances",
        component: SubstanceListe,
        icon: "pe-7s-edit"
    },

    {
        path: "/app/substance/update/:id",
        name: "Substance Update",
        component: SubstanceUpdate,
        hidden: true
    },
    */
    {
        path: "/app/substance/new/",
        name: "Nouvelle Substance",
        component: NewSubstance,
        hidden: true
    },
    {
        path: "/app/analyse/substance/",
        name: "Analyse",
        component: DCIResult,
        hidden: true
    },
    {
        path: "/app/analyse/product/",
        name: "Analyse",
        component: NomResult,
        hidden: true
    },
    {
        path: "/app/analyse/classe/",
        name: "Analyse",
        component: ClasseResult,
        hidden: true
    },
    {
        path: "/app/analyse/nomCommercial/",
        name: "Analyse",
        component: NomCommercialResult,
        hidden: true
    },
    {
        path: "/app",
        pathTo: "/app/product/home",
        redirect: true
    }
];
export default routes;
